import { ServiceIdentifier } from '../service-locator';
import { TokenService } from './interfaces';

export * from './interfaces';
export * from './utils';

export const TOKEN_SERVICE = ServiceIdentifier.get<TokenService>('TokenService');
